import { AccessControlEnum } from '../../core/models/access-control.enum';

export class DataHelper {

  public static hasValue(value: any): boolean {
    return value !== null && value !== undefined;
  }

  public static isNotEmpty(value: any): boolean {
    return this.hasValue(value) && value !== '';
  }

  public static hasAccess(userModules: AccessControlEnum[], modules: AccessControlEnum[]): boolean {
    if (userModules && modules) {
      return userModules?.some((module: string) => {
        return modules.indexOf(module) > -1;
      });
    }
    return false;
  }

  public static isNumeric(value: any): boolean {
    return ((value != null) && (value !== '') && !isNaN(Number(value.toString())));
  }
}
